export function isStreetName(value) {
    return /^[A-Za-z\u00C0-\u017F-\s\d\u002E\u0027]{0,255}$/.test(value || '');
}
